import { render, staticRenderFns } from "./hLargeIconHeader.vue?vue&type=template&id=0049940c&scoped=true"
import script from "./hLargeIconHeader.vue?vue&type=script&lang=js"
export * from "./hLargeIconHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049940c",
  null
  
)

export default component.exports